module.exports = __webpack_public_path__ + "static/media/header-wallet-metamask.432fc6c4.svg";